// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"db90bf65","51":"2c78fd8c","175":"b75aa0b9","678":"31bb1ac3","787":"97686d11","929":"23d8b6f0","933":"a920789e","952":"af819691","956":"c67494dd","987":"2e592216","992":"be08cff9"}[chunkId] + ".chunk.js";
};